export default "__VITE_ASSET__BtR6LUno__"